import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NavigationService } from "../../service/navigation.service";
import { MatButton } from "@angular/material/button";
import { NgSwitch, NgSwitchCase, NgSwitchDefault } from "@angular/common";

@Component({
    selector: "app-error-page",
    templateUrl: "./error-page.component.html",
    styleUrls: ["./error-page.component.scss"],
    imports: [NgSwitch, NgSwitchCase, MatButton, NgSwitchDefault]
})
export class ErrorPageComponent implements OnInit {
  errorNumber;

  constructor(private route: ActivatedRoute, protected navService: NavigationService) {}

  ngOnInit() {
    this.errorNumber = this.route.snapshot.params.error;
  }
}
